@import '~style-sheet-helpers/core.less';

.modal-body {
  width: 600px;
  padding: 20px;
  font-size: 16px;
  line-height: 24px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  > button {
    margin-left: 10px;
  }
}
